<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/Page-header";
import CheckModal from "@/components/CheckModal";
import DocumentActions from "@/components/document/DocumentActions.vue";
import interventionActAPI from "@/services/standards/interventionAct/interventionActAPI";
import newScoresAPI from "@/services/newScores/newScoresAPI";
import Swal from "sweetalert2";
import VersionNote from "@/components/document/VersionNote.vue";

// Catálogo del checklist (espeja config/intervention_activities.php — mismas claves).
const PILARES = [
  {
    pilar: "A. Gestión Estratégica y Legal (PESV y Estándares Mínimos)",
    items: [
      { key: "a1", text: "Socialización / Contextualización sobre la implementación del Plan Estratégico de Seguridad Vial (PESV)." },
      { key: "a2", text: "Revisión de la documentación técnica y legal de vehículos (propios o de terceros utilizados para labores misionales)." },
      { key: "a3", text: "Auditoría / Revisión de cumplimiento de Estándares Mínimos." },
      { key: "a4", text: "Codificación y actualización documental (Plan de Trabajo Anual, Matriz Legal, Matriz de Riesgos IPEVR)." },
    ],
  },
  {
    pilar: "Gestión de Comités Obligatorios (Medicina, Higiene y Seguridad)",
    items: [
      { key: "b1", text: "Acompañamiento / Desarrollo de la reunión periódica del Comité de Convivencia Laboral (COCOLA)." },
      { key: "b2", text: "Capacitación / Socialización sobre modalidades de acoso laboral, prevención del acoso y pautas de convivencia." },
      { key: "b3", text: "Acompañamiento / Desarrollo de la reunión del COPASST (o Vigía de Seguridad y Salud en el Trabajo)." },
      { key: "b4", text: "Capacitación a la Brigada de Emergencia / Seguimiento a simulacros." },
    ],
  },
  {
    pilar: "Medicina del Trabajo y Vigilancia Epidemiológica",
    items: [
      { key: "c1", text: "Revisión y seguimiento al cumplimiento de recomendaciones y restricciones médicas de los trabajadores." },
      { key: "c2", text: "Inspección de puestos de trabajo / Evaluación de condiciones de salud." },
    ],
  },
];

export default {
  page: { title: "Acta de Intervención de Empresa" },
  components: { VersionNote, Layout, PageHeader, CheckModal, DocumentActions },
  data() {
    return {
      // Texto que queda en el control de versiones del PDF
      versionNote: "",
      title: "Acta de Intervención de Empresa",
      items: [
        { text: "Estándares", href: "/forms/estandares" },
        { text: "1.2.2 Acta de Intervención", active: true },
      ],
      companyID: this.$store.getters["company/getCompany"].id || null,
      actaId: this.$route.params.acta || null,
      pilares: PILARES,
      form: {
        intervention_date: null, start_hour: null, end_hour: null, registro_no: null,
        ciudad: null, telefono: null, nivel_riesgo: null, num_trabajadores: null, proxima_visita: null,
        descripcion_actividades: null, recomendaciones: null, observaciones: null,
        profesional_nombre: null, profesional_lps: null, responsable_nombre: null, responsable_cc: null,
      },
      activities: [],
      workflowStatus: "draft",
      signedAt: null,
      submitting: false,
      loading: true,
    };
  },
  computed: {
    isSigned() {
      return this.workflowStatus === "signed";
    },
    interventionApi() {
      return {
        pdfUrl: (id) => interventionActAPI.pdfUrl(id),
        sign: (id, payload) => interventionActAPI.sign(id, payload),
      };
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    load() {
      if (!this.actaId) { this.loading = false; return; }
      interventionActAPI.get(this.actaId)
        .then((r) => {
          if (!r) return;
          Object.keys(this.form).forEach((k) => {
            if (r[k] !== undefined) {
              this.form[k] = (k.includes("date") || k === "proxima_visita") && r[k]
                ? String(r[k]).substring(0, 10) : r[k];
            }
          });
          this.activities = Array.isArray(r.activities) ? r.activities : [];
          this.workflowStatus = r.workflow_status || "draft";
          this.signedAt = r.signed_at || null;
          this.loading = false;
        })
        .catch((e) => { console.log(e); this.loading = false; });
    },
    save() {
      if (this.isSigned) return;
      this.submitting = true;
      const payload = { ...this.form, companies_id: this.companyID, activities: this.activities };
      payload.version_note = this.versionNote;
      const req = this.actaId
        ? interventionActAPI.update(this.actaId, payload)
        : interventionActAPI.save(payload);
      req
        .then((res) => {
          newScoresAPI.calculateScores({ companies_id: this.companyID, item_id: 10, status: "Pendiente" }).catch(() => {});
          Swal.fire({ title: "¡Éxito!", text: "Acta guardada con éxito.", icon: "success", timer: 1800, showConfirmButton: false });
          this.submitting = false;
          if (!this.actaId && res && res.id) {
            this.actaId = res.id;
            this.$router.replace({ path: `/forms/estandares/${this.companyID}/acta-intervencion/${res.id}` });
          }
        })
        .catch((e) => {
          console.log(e);
          this.submitting = false;
          Swal.fire("Error", "No se pudo guardar el acta", "error");
        });
    },
    onSigned(payload) {
      this.workflowStatus = payload.workflow_status;
      this.signedAt = payload.signed_at;
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-9" v-if="!loading">
        <div class="card">
          <div class="card-body">
            <CheckModal>
              <p class="text-justify">
                Registra la visita de intervención del profesional SST: datos de la visita, actividades realizadas
                (checklist por pilares), descripción, recomendaciones y observaciones. La plataforma genera el acta
                para la firma del encargado de la empresa.
              </p>
            </CheckModal>

            <div v-if="isSigned" class="alert alert-success py-2 my-2 small">
              🔒 Esta acta ya fue firmada; los datos quedan bloqueados para edición.
            </div>

            <form @submit.prevent="save">
              <h5 class="pt-2">Datos de la visita</h5>
              <div class="form-row">
                <b-form-group class="col-md-4 px-2" label="Fecha de la intervención">
                  <b-form-input type="date" v-model="form.intervention_date" :disabled="isSigned" required />
                </b-form-group>
                <b-form-group class="col-md-4 px-2" label="Hora inicio">
                  <b-form-input type="time" v-model="form.start_hour" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-4 px-2" label="Hora finalización">
                  <b-form-input type="time" v-model="form.end_hour" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-4 px-2" label="Registro N°">
                  <b-form-input type="text" v-model="form.registro_no" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-4 px-2" label="Ciudad / Municipio">
                  <b-form-input type="text" v-model="form.ciudad" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-4 px-2" label="Teléfono">
                  <b-form-input type="text" v-model="form.telefono" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-4 px-2" label="Nivel de riesgo ARL">
                  <b-form-select v-model="form.nivel_riesgo" :disabled="isSigned" class="form-control">
                    <b-form-select-option :value="null">—</b-form-select-option>
                    <b-form-select-option v-for="n in ['I','II','III','IV','V']" :key="n" :value="n">{{ n }}</b-form-select-option>
                  </b-form-select>
                </b-form-group>
                <b-form-group class="col-md-4 px-2" label="N° de trabajadores">
                  <b-form-input type="number" min="0" v-model="form.num_trabajadores" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-4 px-2" label="Próxima visita">
                  <b-form-input type="date" v-model="form.proxima_visita" :disabled="isSigned" />
                </b-form-group>
              </div>

              <hr />
              <h5>Actividades realizadas durante la intervención</h5>
              <p class="text-muted small">Marca las actividades ejecutadas en la visita.</p>
              <div v-for="(p, pi) in pilares" :key="pi" class="mb-2">
                <p class="font-weight-bold mb-1">{{ p.pilar }}</p>
                <b-form-checkbox v-for="it in p.items" :key="it.key" v-model="activities" :value="it.key"
                  :disabled="isSigned" class="small mb-1">
                  {{ it.text }}
                </b-form-checkbox>
              </div>

              <hr />
              <b-form-group label="Descripción detallada de actividades del día">
                <b-form-textarea v-model="form.descripcion_actividades" :disabled="isSigned" rows="3" />
              </b-form-group>
              <b-form-group label="Recomendaciones de Seguridad y Salud en el Trabajo">
                <b-form-textarea v-model="form.recomendaciones" :disabled="isSigned" rows="3" />
              </b-form-group>
              <b-form-group label="Observaciones generales y compromisos">
                <b-form-textarea v-model="form.observaciones" :disabled="isSigned" rows="3" />
              </b-form-group>

              <hr />
              <h5>Firmantes</h5>
              <div class="form-row">
                <b-form-group class="col-md-6 px-2" label="Profesional SST (nombre)">
                  <b-form-input type="text" v-model="form.profesional_nombre" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-6 px-2" label="L.P.S. (licencia)">
                  <b-form-input type="text" v-model="form.profesional_lps" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-6 px-2" label="Responsable de la empresa (nombre)">
                  <b-form-input type="text" v-model="form.responsable_nombre" :disabled="isSigned" />
                </b-form-group>
                <b-form-group class="col-md-6 px-2" label="C.C. responsable">
                  <b-form-input type="text" v-model="form.responsable_cc" :disabled="isSigned" />
                </b-form-group>
              </div>

              <VersionNote v-model="versionNote" :editing="!!actaId" />

              <div class="text-right">
                <button type="submit" :disabled="isSigned || submitting" class="btn btn-primary mx-1">Guardar</button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-3" v-if="!loading && actaId">
        <h6 class="text-muted small mb-1">Acta de Intervención</h6>
        <DocumentActions
          :document-id="Number(actaId)"
          :company-id="companyID"
          :workflow-status="workflowStatus"
          :signed-at="signedAt"
          :api-service="interventionApi"
          document-title="Acta de Intervención de Empresa"
          signer-role="gerente"
          @signed="onSigned"
        />
      </div>

      <div v-if="loading" class="col-12 text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </div>
  </Layout>
</template>
